import { useRuntimeConfig } from '#app'
import { computed } from 'vue'

import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

export function useListingPagePreference() {
  const runtimeConfig = useRuntimeConfig()

  const { isFeatureEnabled } = useBusinessFeaturesStore()

  const { FF_BO_SELLER_ENABLE_LISTINGS_PAGE_V2 } = runtimeConfig.public
  const islistingsPageSellerSpecificeEnabled = isFeatureEnabled(
    'isRevampedListingsPageEnabled',
  )

  // If the feature flag is enabled, and the seller is part of the specific sellers, they should see the new listings page as default
  const isListingsPageV2Default = computed(
    () =>
      islistingsPageSellerSpecificeEnabled &&
      FF_BO_SELLER_ENABLE_LISTINGS_PAGE_V2,
  )

  return {
    isListingsPageV2Default,
  }
}
